<template>
  <div 
    class="  px-10 mt-6">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <section>
          <div class="color-dark-blue fs-16 font-weight-bold">
            Tambahkan Kategori
          </div>

          <v-card 
            class="mt-4"
            flat
            height="calc(100vh - 200px)"
            style="background: transparent; border: 1px solid #E7E7E7;">
            <v-card-text class="">

              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="Nama Kategori Pegawai" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-15 label-input mb-2">
                          Nama Kategori Pegawai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. Admin"

                          
                          :item-color="set_color"

                          v-model="form.title"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <div>
                    <div class="fs-15 label-input mb-2">
                      Hak Akses
                    </div>

                    <div
                      style="height: calc(100vh - 400px); overflow-y: auto;" class="px-5">
                      <div v-for="(item, index) in list" :key="index">
                        <v-checkbox hide-details :value="item.id" v-model="form.menu_arr" >
                          <template v-slot:label>
                            <div class="d-flex align-center">
                              <v-icon size="18">{{ item.icon }}</v-icon>
                              <div class="black--text ml-2 fs-14">{{ item.label }}</div>
                            </div>
                          </template>
                        </v-checkbox>
                        <div v-if="Object.keys(item.action).length > 0">
                          <div v-if="item.id === 1" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_sub" :disabled="form.menu_arr.filter(function(v) { return v === 1 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 1 }).length < 1 ? '' : 'black--text'">
                                  Tambah Sub
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 4" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.list_template" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                  Template
                                </div>
                              </template>
                            </v-checkbox>
                            <!-- <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_template" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                  Tambah Template
                                </div>
                              </template>
                            </v-checkbox> -->
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_verification" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                  Hapus Verifikasi
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.varification" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                  Verifikasi
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 4 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 4 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 5" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 5 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 5 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 2" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 2 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 2 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>  

                          <div v-if="item.id === 3" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 3 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 3 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>  

                          <div v-if="item.id === 6" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.buka_buku" :disabled="form.menu_arr.filter(function(v) { return v === 6 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 6 }).length < 1 ? '' : 'black--text'">
                                  Buka Buku
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.tutup_buku" :disabled="form.menu_arr.filter(function(v) { return v === 6 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 6 }).length < 1 ? '' : 'black--text'">
                                  Tutup Buku
                                </div>
                              </template>
                            </v-checkbox>
                          </div>  

                          <div v-if="item.id === 7" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Tambah & Ubah Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Hapus Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <!-- <v-checkbox hide-details class="mx-4" dense v-model="item.action.data_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Data Report Rencana
                                </div>
                              </template>
                            </v-checkbox> -->
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Tambah Report Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Hapus Report Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 7 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 7 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 8" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Tambah & Ubah Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Hapus Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <!-- <v-checkbox hide-details class="mx-4" dense v-model="item.action.data_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Data Report Rencana
                                </div>
                              </template>
                            </v-checkbox> -->
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Tambah Report Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Hapus Report Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 8 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 8 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 11" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.reset_password" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Reset Password
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 11 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 11 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 12" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 12 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 12 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 12 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 12 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 12 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 12 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                          </div>

                          <div v-if="item.id === 14" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.add" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Tambah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.update" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Ubah
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Hapus
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Tambah & Ubah Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Hapus Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <!-- <v-checkbox hide-details class="mx-4" dense v-model="item.action.data_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Data Report Rencana
                                </div>
                              </template>
                            </v-checkbox> -->
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Tambah Report Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_report_rencana" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Hapus Report Rencana
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.add_project" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Tambah Project
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mx-4" dense v-model="item.action.delete_project" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Hapus Project
                                </div>
                              </template>
                            </v-checkbox>
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 14 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 14 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>


                          <div v-if="item.id === 53" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 53 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 53 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>


                          <div v-if="item.id === 9" class="ml-5 d-flex align-center fs-12">
                            <v-checkbox hide-details class="mr-4 ml-2" dense v-model="item.action.export" :disabled="form.menu_arr.filter(function(v) { return v === 9 }).length < 1">
                              <template v-slot:label>
                                <div class="fs-12" :class="form.menu_arr.filter(function(v) { return v === 9 }).length < 1 ? '' : 'black--text'">
                                  Export
                                </div>
                              </template>
                            </v-checkbox>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>


          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-3"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/category-user"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>

          <!-- <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row> -->
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        role: [
          {
            id: 1,
            name: 'Admin'
          },
          {
            id: 2,
            name: 'Pegawai' 
          }
        ],
        list:[
          {
            id: 1,
            label: "CoA",
            icon: "mdi-file-cog",
            link: "/coa",
            color: "primary",
            action: {
              add: false,
              update: false,
              delete: false,
              export: false,
              add_sub: false
            }
          },
          {
            id: 52,
            label: "Set Saldo Awal",
            icon: "mdi-currency-usd",
            link: "/set-saldo-awal",
            color: "pink",
            action: []
          },
          {
            id: 4,
            label: "Jurnal",
            icon: "mdi-file-document-edit-outline",
            color: "warning",
            link: "/jurnal",
            action: {
              add: false,
              list_template: false,
              // add_template: false,
              delete_verification: false,
              varification: false,
              update: false
            }
          },
          {
            id: 5,
            label: "Buku Besar",
            icon: "mdi-book-open-blank-variant",
            link: "/buku-besar",
            color: "success",
            action: {
              export: false
            }
          },
          {
            id: 2,
            label: "Neraca",
            icon: "mdi-scale-balance",
            link: "/neraca",
            color: "accent",
            action:{
              export: false
            }
          },
          {
            id: 3,
            label: "Laba Rugi",
            icon: "mdi-chart-bell-curve-cumulative",
            link: "/laba-rugi",
            color: "pink",
            action: {
              export: false
            }
          },
          {
            id: 6,
            label: "Tutup Buku",
            icon: "mdi-book-remove",
            link: "/trial-balance",
            color: "#3E2723",
            action: {
              buka_buku: false,
              tutup_buku: false
            }
          },
          {
            id: 7,
            label: "Project",
            icon: "mdi-folder-account",
            link: "/project",
            color: "#00838F",
            action: {
              add: false,
              update: false,
              delete: false,
              add_rencana: false,
              delete_rencana: false,
              export: false,
              // data_report_rencana: false,
              add_report_rencana: false,
              delete_report_rencana: false
            }
          },
          {
            id: 14,
            label: "Vendor",
            icon: "mdi-home-account",
            link: "/vendor",
            color: "#00838F",
            action: {
              add: false,
              update: false,
              delete: false,
              add_rencana: false,
              delete_rencana: false,
              export: false,
              // data_report_rencana: false,
              add_report_rencana: false,
              delete_report_rencana: false,
              add_project: false,
              delete_project: false
            }
          },
          {
            id: 8,
            label: "Divisi",
            icon: "mdi-bookmark-box",
            link: "/divisi",
            color: "#BF360C",
            action: {
              add: false,
              update: false,
              delete: false,
              add_rencana: false,
              delete_rencana: false,
              export: false,
              // data_report_rencana: false,
              add_report_rencana: false,
              delete_report_rencana: false
            }
          },
          {
            id: 53,
            label: "Laporan Sub Keuangan",
            icon: "mdi-file-document",
            link: "/laporan-sub-keuangan",
            color: "#827717",
            action: {
              export: false,
            }
          },
          {
            id: 9,
            label: "Audit Trail",
            icon: "mdi-list-box",
            link: "/audit",
            color: "#455A64",
            action:{
              export: false,
            }
          },
          {
            id: 10,
            label: "Kelola Jurnal",
            icon: "mdi-archive-edit",
            link: "/manage-jurnal",
            color: "red",
            action:{}
          },
          {
            id: 11,
            label: "Pegawai",
            icon: "mdi-account-group",
            link: "/user",
            color: "primary",
            action: {
              add: false,
              update: false,
              delete: false,
              reset_password: false,
              export: false,
            }
          },
          {
            id: 12,
            label: "Kategori Pegawai",
            icon: "mdi-shape",
            link: "/category-user",
            color: "#4A148C",
            action: {
              add: false,
              update: false,
              delete: false
            }
          },
          {
            id: 13,
            label: "Konfigurasi",
            icon: "mdi-cog-outline",
            link: "/config",
            color: "black",
            action:{}
          }
        ],

        form: {
          id: '',
          title: '',
          menu_arr: []
        },

        process: {
          load: false,

          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.id': function() {
        let t = this

        let r = this.role.filter(function(v) {
          return t.form.id == v
        })

        if (r.length > 0) {
          this.form.title = r[0].name
          
          this.fetchRole()
        }
      },
      'form.menu_arr': function(val) {
        val.filter(function(v) {
          return v === 1
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 1) {
            console.log(l)
            l.action = {
              add: false,
              update: false,
              delete: false,
              export: false,
              add_sub: false
            }
          }
        }) : ''
        val.filter(function(v) {
          return v === 4
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 4) {
            l.action = {
              add: false,
              list_template: false,
              // add_template: false,
              delete_verification: false,
              varification: false,
              update: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 5
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 5) {
            l.action = {
              export: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 2
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 2) {
            l.action = {
              export: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 3
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 3) {
            l.action = {
              export: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 6
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 6) {
            l.action = {
              buka_buku: false,
              tutup_buku: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 7
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 7) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              add_rencana: false,
              delete_rencana: false,
              // data_report_rencana: false,
              export: false,
              add_report_rencana: false,
              delete_report_rencana: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 8
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 8) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              add_rencana: false,
              delete_rencana: false,
              export: false,
              // data_report_rencana: false,
              add_report_rencana: false,
              delete_report_rencana: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 11
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 11) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              export: false,
              reset_password: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 12
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 12) {
            l.action = {
              add: false,
              update: false,
              delete: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 14
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 14) {
            l.action = {
              add: false,
              update: false,
              delete: false,
              add_rencana: false,
              delete_rencana: false,
              export: false,
              // data_report_rencana: false,
              add_report_rencana: false,
              delete_report_rencana: false,
              add_project: false,
              delete_project: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 53
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 53) {
            l.action = {
              export: false
            }
          }
        }) : ''

        val.filter(function(v) {
          return v === 9
        }).length < 1 ? this.list.map(function(l) {
          if (l.id === 9) {
            l.action = {
              export: false
            }
          }
        }) : ''
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      // this.fetchRole()
    },
    mounted () {
      
    },
    methods: {
      


      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          // console.log(this.array_final())
          // let form = {
          //   title: this.form.title,
          //   menu_arr: JSON.stringify(this.form.menu_arr)
          // }
          let menu = []
          for(let l in this.list){
            for(let a in this.form.menu_arr){
              if(this.list[l].id == this.form.menu_arr[a]){
                menu.push(this.list[l])
              }
            }
          } 

          // this.form.menu_arr = JSON.stringify(this.array_final())

          // this.form.menu_arr = JSON.stringify(this.list)

          // SAVE TO REST API
          await post('admin/category/add', {
            data: {
              title: this.form.title,
              menu_array: menu
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message
              this.$router.push({ path: '/category-user' })

              // this.fetchRole()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>